export function OutlineGroupIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0382 8.00195H3.95976C3.42956 8.00195 2.99976 8.43176 2.99976 8.96196V20.0404C2.99976 20.5706 3.42956 21.0004 3.95976 21.0004H15.0382C15.5684 21.0004 15.9982 20.5706 15.9982 20.0404V8.96196C15.9982 8.43176 15.5684 8.00195 15.0382 8.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M8.00122 8.00161V3.9552C8.00122 3.36 8.48602 3 9.07642 3H19.9244C20.5196 3 20.9996 3.48 20.9996 4.0752V14.9232C20.9996 15.5136 20.5196 15.9984 19.9244 15.9984H16.0028"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M9.49902 12V17.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9999 14.5H6.99829"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
